import React, { useState, useEffect } from "react";
import FeedbackList from "./feedbackList";
import DashboardLayout from "../DashboardLayout";
import { handleErrors } from "../../services/dataManager";
import {
  fetchFeedbackCategories,
  fetchPaginatedFeedback,
} from "../../services/axios/apiManager";
import { useAppContext } from "../../services/context";

const Feedbacks = ({ navigate }) => {
  const { state } = useAppContext();
  const { permissions } = state;
  const [feedbacks, setFeedbacks] = useState([]);
  const [categories, setCategories] = useState([]);
  const [pagination, setPagination] = useState({});
  const [granted, setGranted] = useState([]);

  const extractPermissions = () => {
    const perms = permissions.filter((f) => f.module === "Feedbacks");
    if (perms) {
      setGranted(perms);
    }
  };

  const getData = async () => {
    const res = await fetchPaginatedFeedback();
    if (res?.data?.success && res?.data?.data) {
      setFeedbacks(res.data.data);
      if (res?.data?.pagination) {
        setPagination(res.data.pagination);
      }
    } else {
      handleErrors(res, navigate);
    }
    const categoriesResponse = await fetchFeedbackCategories();
    if (categoriesResponse?.data?.data) {
      setCategories(categoriesResponse.data.data);
    }
  };

  useEffect(() => {
    extractPermissions();
    getData();
  }, []);

  return (
    <DashboardLayout>
      <div data-testid="KbManagement">
        <div className="row">
          <div className="col-12 mb-3">
            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
              <div className="page-title-right">
                <ol className="breadcrumb m-0">
                  <li className="breadcrumb-item">
                    <a>Dashboard</a>
                  </li>
                  <li
                    className="breadcrumb-item active"
                    style={{ color: "#d1cdcdbf" }}
                  >
                    Trouble Tickets
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
        <FeedbackList
          feedbacks={feedbacks}
          setFeedbacks={setFeedbacks}
          pagination={pagination}
          setPagination={setPagination}
          categories={categories}
          setCategories={setCategories}
          granted={granted}
        />
      </div>
    </DashboardLayout>
  );
};

export default Feedbacks;
